import { CheckCircle2, GripVertical, Pencil, Trash2, Users } from "lucide-react";
import { mediaSrc } from "@/lib/media";

const GuidePhoto = ({ g }) => {
  if (!g.photo_url) return <span className="grid place-items-center w-14 h-14 rounded-full bg-accent/10 text-accent shrink-0"><Users size={22} /></span>;
  const pos = `${g.photo_position_x ?? 50}% ${g.photo_position_y ?? 50}%`;
  return <img src={mediaSrc(g.photo_url)} alt={g.name} className="w-14 h-14 rounded-full object-cover shrink-0" style={{ objectPosition: pos, transform: `scale(${g.photo_zoom ?? 1})`, transformOrigin: pos }} />;
};

export const GuideRow = ({ g, index, publicIndex, onDragStart, onDrop, approveGuide, startEditG, deleteGuide }) => {
  const isPending = g.status === "pending";
  return (
    <div data-testid={`guide-row-${g.id}`} onDragOver={(e) => e.preventDefault()} onDrop={() => onDrop(index)} className="rounded-2xl border border-border bg-background/60 p-4 flex items-center gap-3">
      <button type="button" draggable data-testid={`guide-drag-${g.id}`} onDragStart={() => onDragStart(index)} title="Drag to reorder"
        className="shrink-0 grid place-items-center w-6 h-8 text-muted-foreground/60 hover:text-accent cursor-grab active:cursor-grabbing">
        <GripVertical size={16} />
      </button>
      <span data-testid={`guide-order-${index}`} title="Public display position" className="shrink-0 inline-flex items-center justify-center min-w-[2.25rem] h-7 rounded-full bg-accent/10 text-accent text-xs font-semibold">
        {isPending ? "Pending" : `#${publicIndex + 1}`}
      </span>
      <GuidePhoto g={g} />
      <div className="min-w-0 flex-1">
        <p className="font-medium truncate">{g.name}</p>
        <p className="text-xs text-muted-foreground truncate">{g.profession}</p>
        <p className="text-xs text-accent truncate">{g.place}</p>
        {g.batch && <p className="text-xs text-muted-foreground truncate">Batch: {g.batch}</p>}
        {g.phone && <p className="text-xs text-muted-foreground truncate">Phone: {g.phone}</p>}
        {isPending && <span data-testid={`guide-pending-${g.id}`} className="mt-1 inline-flex rounded-full bg-[#E0A63C]/10 px-2 py-0.5 text-[11px] font-medium text-[#8A5A00]">Pending approval</span>}
        {g.bio && <p className="text-xs text-foreground/70 mt-1 line-clamp-2">{g.bio}</p>}
      </div>
      <div className="shrink-0 inline-flex flex-col gap-2">
        {isPending && (
          <button data-testid={`guide-approve-${g.id}`} onClick={() => approveGuide(g)} title="Approve guide" className="grid place-items-center w-8 h-8 rounded-full bg-[#128C4B] text-white hover:-translate-y-0.5 transition-transform">
            <CheckCircle2 size={15} />
          </button>
        )}
        <button data-testid={`guide-edit-${g.id}`} onClick={() => startEditG(g)} title="Edit" className="grid place-items-center w-8 h-8 rounded-full border border-border hover:bg-primary hover:text-primary-foreground transition-colors">
          <Pencil size={14} />
        </button>
        <button data-testid={`guide-delete-${g.id}`} onClick={() => deleteGuide(g)} title="Delete" className="grid place-items-center w-8 h-8 rounded-full border border-destructive/40 text-destructive hover:bg-destructive hover:text-white transition-colors">
          <Trash2 size={14} />
        </button>
      </div>
    </div>
  );
};
